import { useEffect, useState } from "react";
import { UploadDataModal } from "../modal";
import { GradientButton } from "../GradientButton";
import { useStateWithSearchParams } from "../../../hooks";

export const UploadDataBtn = ({
  campaign_id,
  fullWidth,
}: {
  campaign_id: string;
  fullWidth?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { searchDict } = useStateWithSearchParams<{
    crm?: string;
    actionType?: string;
  }>({
    crm: undefined,
    actionType: undefined,
  });

  useEffect(() => {
    if (searchDict.crm && searchDict.actionType === "upload") {
      setIsOpen(true);
    }
  }, [searchDict]);

  return (
    <>
      <GradientButton fullWidth={fullWidth} onClick={() => setIsOpen(true)}>
        Upload Data
      </GradientButton>
      {isOpen && (
        <UploadDataModal
          campaign_id={campaign_id}
          hasFileImports={false}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      )}
    </>
  );
};
